import React from 'react';
import email from '../../Assets/elvotaimages/email.png';
import linkedin from '../../Assets/elvotaimages/linkedin.png';

export default function Bess() {
  return (
    <div className="footer-bg border-solid border-b-8 border-[#A1FF75]">
      <div className="w-11/12 2xl:w-[1216px] mx-auto sm:h-[66px] content-center ">
        <div className="grid grid-cols-12 items-center">
          {/* Copyright Section */}
          <div className="col-span-12 sm:col-span-4 order-2 sm:order-1">
            <div className="text-center sm:text-start mt-5 sm:mt-0">
              <h1 className="f-f-r text-lg text-grey footer-font">
                Copyright © 2024 Evolta Technologies SA
              </h1>
            </div>
          </div>

          {/* Social Icons Section */}
          <div className="col-span-12 sm:col-span-4 order-1 sm:order-2">
            <div className="flex justify-center ">
              <ul className="flex items-center space-x-6">
                <li>
                  <a
                    href="mailto:contact@evolta-technologies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={email} // Replace with your email icon image path
                      alt="Email Icon"
                      className="w-4 h-4" // Adjust size as needed
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/evolta-technologies/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={linkedin} // Replace with your LinkedIn icon image path
                      alt="LinkedIn Icon"
                      className="w-4 h-4" // Adjust size as needed
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Designed & Developed Section */}
          <div className="col-span-12 sm:col-span-4 order-3 sm:order-3 mt-5 sm:mt-0 mb-5 sm:mb-0">
            <div className="text-center sm:text-start">
              <h1 className="f-f-r text-lg text-grey footer-font">
                Designed & developed by{' '}
                <u>
                  <a
                    href="https://amigaze.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {' '}
                    Amigaze{' '}
                  </a>
                </u>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
